export default "__VITE_ASSET__CzsWs5W0__"